import type from 'type-detect';

class ArrayHelper {
	/**
	 * makeUint8Array - converts input array into a Uint8Array
	 * Will only make a change for an ArrayBuffer, otherwise
	 * the return value is unmodified
	 */
	static makeUint8Array( array ) {
		let result = array;
		let arrayType = type(result);

		if( arrayType !== 'Uint8Array' ) {

			if( arrayType === 'ArrayBuffer' /*|| arrayType === 'Array'*/ ) {
				result = new Uint8Array(result);
			}

			// can add other typed arrays as || here
			else if( arrayType === 'Int32Array' ) {
				result = new Uint8Array( result.buffer, result.byteOffset, result.byteLength );
			}

			// TODO: add other formats here

			else {
				throw new Error(`ArrayHelper.makeUint8Array unhandled array type ${arrayType}`);
			}

		}

		return result;
	}

	/**
	 * makeModulo16 - truncates a uint8Array to modulo-16
	 *
	 * Returns obj with { data,truncated }, where truncated
	 * is a bool indicating if truncation occurred
	 *
	 * input must be Uint8Array.
	 */
	static makeModulo16(data) {
		if( type(data) !== 'Uint8Array' ) {
			throw new Error( `ArrayHelper.makeModulo16 data must be Uint8Array {${type(data)}}`);
		}

		let myData = data;
		let truncated = false;

		let len = data.length;
		let lenMod16 = len % 16;

		if( lenMod16 !== 0 ) {
			myData = myData.subarray(0, len - lenMod16);

			// we need to add padding because we truncated.
			truncated = true;
		}

		return { data : myData, truncated };
	}
}

export default ArrayHelper;



// WEBPACK FOOTER //
// ./src/helpers/ArrayHelper.js